import {
  BACKSPACE,
  C,
  DELETE,
  DOWN_ARROW,
  END,
  ENTER,
  hasModifierKey,
  HOME,
  LEFT_ARROW,
  RIGHT_ARROW,
  TAB,
  UP_ARROW,
  V
} from '@angular/cdk/keycodes';

export function onlyNumberKeysAllowed(event: KeyboardEvent): boolean {
  return isSpecialKey(event) || /[0-9]/.test(event.key);
}

export function onlyNumberKeysAndPlusAllowed(event: KeyboardEvent): boolean {
  return isSpecialKey(event) || /[0-9+]/.test(event.key);
}

export function onlyNumberKeysAndMinusAllowed(event: KeyboardEvent): boolean {
  return isSpecialKey(event) || /[0-9-]/.test(event.key);
}

export function onlyNumberKeysAndDotAllowed(event: KeyboardEvent): boolean {
  return isSpecialKey(event) || /[0-9\.]/.test(event.key);
}

export function onlyNumberKeysDotsAndMinusAllowed(event: KeyboardEvent): boolean {
  return isSpecialKey(event) || /[0-9\.-]/.test(event.key);
}

export function onlyNumberKeysAndCommasAllowed(event: KeyboardEvent): boolean {
  return isSpecialKey(event) || /[0-9,]/.test(event.key);
}

export function onlyNumberKeysCommasAndMinusAllowed(event: KeyboardEvent): boolean {
  return isSpecialKey(event) || /[0-9,-]/.test(event.key);
}

export function isSpecialKey(event: KeyboardEvent): boolean {
  const key = event.keyCode;
  return (
    (hasModifierKey(event, 'ctrlKey') && (key === C || key === V)) ||
    key === LEFT_ARROW ||
    key === RIGHT_ARROW ||
    key === UP_ARROW ||
    key === DOWN_ARROW ||
    key === HOME ||
    key === END ||
    key === TAB ||
    key === ENTER ||
    key === BACKSPACE ||
    key === DELETE
  );
}
